import React from "react";
// import Header from "../../Layouts/Header";
import SmartVitalsChecker from "./SmartVitalsChecker";

export default function SmartVitalsInstruct() {
    return (
        <>
            {/* <Header /> */}
            {/* Main content area */}
            <div className="flex flex-col items-center w-full px-4">
                <SmartVitalsChecker />
            </div>
        </>
    );
}

